export default __webpack_public_path__ + "static/cabin-latin-700-normal-e9de09f06a265ad4ac186032fadbc629.woff2";